export default __webpack_public_path__ + "static/logo-mobile-0e10bd7efb82e873bb2326ae78cdd0c7.svg";